import type { Nullable, WellId } from 'common/types'

import type { ActiveEntity, SelectedTreeObject } from '../types'

export function getActiveEntity(treeObject: Nullable<SelectedTreeObject>): Nullable<ActiveEntity> {
  if (treeObject == null) return null

  const { entityId, entityType, entityName, customProperties } = treeObject
  return { entityId, entityType, entityName, customProperties }
}

export function isWellId(
  entityId: ActiveEntity['entityId'],
  entityType: ActiveEntity['entityType'],
): entityId is WellId {
  return entityType === 'well' && entityId != null
}
